import { NonLinearAds, TrackingEvents } from '@lib/iab/iab-vast-model';

import createNonLinear from './non-linear';
import isNonEmptyArray from '../util/is-non-empty-array';
import mapTrackingEvents from '../util/map-tracking-events';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createNonLinearAds = ($creative: UnmarshalerNode): NonLinearAds => {
    const $nonLinearAds = $creative.nonLinearAds as UnmarshalerNode;
    const nonLinearAds = new NonLinearAds();

    if ($nonLinearAds.nonLinear != null) {
        nonLinearAds.nonLinears.push(
            ...($nonLinearAds.nonLinear as UnmarshalerNode[]).map(
                createNonLinear
            )
        );
    }

    if (
        $nonLinearAds.trackingEvents != null &&
        isNonEmptyArray(
            ($nonLinearAds.trackingEvents as UnmarshalerNode).tracking
        )
    ) {
        nonLinearAds.trackingEvents = new TrackingEvents();
        mapTrackingEvents(
            $nonLinearAds.trackingEvents as UnmarshalerNode,
            nonLinearAds.trackingEvents,
            { errorHandler: { tryRecover: () => {} } }
        );
    }

    return nonLinearAds;
};

export default createNonLinearAds;
